import { render } from "./Form2Ver2.vue?vue&type=template&id=a983973e"
import script from "./Form2Ver2.vue?vue&type=script&lang=js"
export * from "./Form2Ver2.vue?vue&type=script&lang=js"

import "./Form2Ver2.vue?vue&type=style&index=0&id=a983973e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__